import React from 'react';

const MultipleUserIcon: React.FC = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 19C18.7629 19 21 16.7629 21 14C21 11.2371 18.7629 9 16 9C13.2371 9 11 11.2371 11 14C11 16.7629 13.2371 19 16 19ZM16 21C19.8675 21 23 17.8675 23 14C23 10.1325 19.8675 7 16 7C12.1325 7 9 10.1325 9 14C9 17.8675 12.1325 21 16 21Z"
        fill="#120242"
        stroke="#120242"
        strokeWidth="1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.76618 28.0846C5.14556 28.6486 5 29.0826 5 29.4V33H27V29.4C27 29.0826 26.8544 28.6486 26.2338 28.0846C25.6009 27.5095 24.6268 26.9511 23.3932 26.4645C20.924 25.4906 17.9234 25 16 25C14.0766 25 11.076 25.4906 8.60682 26.4645C7.37322 26.9511 6.39908 27.5095 5.76618 28.0846ZM16 23C11.6612 23 3 25.144 3 29.4V35H29V29.4C29 25.144 20.3387 23 16 23Z"
        fill="#120242"
        stroke="#120242"
        strokeWidth="1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35 21C36.6579 21 38 19.6579 38 18C38 16.3421 36.6579 15 35 15C33.3421 15 32 16.3421 32 18C32 19.6579 33.3421 21 35 21ZM35 23C37.7625 23 40 20.7625 40 18C40 15.2375 37.7625 13 35 13C32.2375 13 30 15.2375 30 18C30 20.7625 32.2375 23 35 23Z"
        fill="#120242"
        stroke="#120242"
        strokeWidth="1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 33H43V30.3333C43 30.1329 42.9211 29.8399 42.5037 29.429C42.0689 29.0009 41.3774 28.5654 40.4657 28.1758C38.6335 27.3929 36.401 27 35 27C33.5989 27 31.3665 27.3929 29.5343 28.1758C28.8492 28.4686 28.2884 28.7873 27.8674 29.1093C27.672 28.4546 27.2808 27.8736 26.8304 27.389C29.0493 25.799 32.7681 25 35 25C38.3375 25 45 26.7867 45 30.3333V33V35H43H28V33Z"
        fill="#120242"
        stroke="#120242"
        strokeWidth="1"
      />
    </g>
  </svg>
);

export default MultipleUserIcon;
